export default __webpack_public_path__ + "static/media/cyrus.bd62099f.png";